export default __webpack_public_path__ + "static/media/memcached-negative.fa7973af.svg";